<template>
  <div id="pageTable" class="mainView">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
          <v-btn color="primary" dark slot="activator" @click="openDialogCoupon">쿠폰 추가하기</v-btn>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <div class="flex xs12 sm2">
                <v-select
                        :items="[{
                          text: '이름',
                          value: 'title'
                        }]"
                        name="header"
                        v-model="searchFormModel.filter"
                        label="header"
                ></v-select>
              </div>
              <v-text-field
                      flat
                      solo
                      prepend-icon="search"
                      placeholder="Type something"
                      v-model="searchFormModel.filterText"
                      hide-details
                      class="hidden-sm-and-down"
                      @keyup.enter="searchFilter"
              ></v-text-field>
              <v-btn icon @click="searchFilter">
                <v-icon>filter_list</v-icon>
              </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="complex.headers"
                :items="complex.items"
                :rows-per-page-items="[10,25,50]"
                class="elevation-1"
                item-key="id"
                must-sort
                :pagination.sync="pagination"
                :total-items="totalItems"
                >
                <template slot="items" slot-scope="props">           
                  <td class="text-sm-center"><a @click="openDialogDetail(props.item)">{{ props.item.id }}</a></td>
                  <td class="text-sm-center">{{ props.item.title }}</td>
                  <td class="text-sm-center">{{ props.item.description }}</td>
                  <td class="text-sm-center">{{ changeCouponTypeText(props.item.couponType) }}</td>
                  <td class="text-sm-center">{{ props.item.amount }}</td>
                  <td class="text-sm-center">{{ props.item.days }}</td>
                  <td class="text-sm-center">
                    <v-btn color="primary" slot="activator" @click="openHistory(props.item.id)">발급내역</v-btn>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-dialog v-model="coupon.dialog" max-width="500px">
          <v-card>
            <v-card-title>
              <span class="headline">쿠폰 생성</span>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-select
                            :items="state"
                            v-model="formModel.state"
                            label="쿠폰 종류"
                            item-text="text"
                            item-value="state"
                    >
                    </v-select>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                            label="쿠폰 제목"
                            v-model="formModel.title"
                            v-validate="formRequired"
                            data-vv-name="title"
                            :error-messages="errors.collect('title')"
                            required></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                            label="쿠폰 설명"
                            v-model="formModel.description"
                            v-validate="formRequired"
                            data-vv-name="description"
                            :error-messages="errors.collect('description')"
                            required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field
                            label="쿠폰 금액"
                            mask="####################"
                            v-model="formModel.amount"
                            v-validate="formRequired"
                            data-vv-name="amount"
                            :error-messages="errors.collect('amount')"
                            required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field
                            label="유효 기간"
                            mask="####################"
                            v-model="formModel.days"
                            v-validate="formRequired"
                            data-vv-name="days"
                            :error-messages="errors.collect('days')"
                            required></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer>
              </v-spacer>
              <v-btn color="blue darken-1" flat @click="closeDialogCoupon">Close</v-btn>
              <v-btn color="blue darken-1" flat @click="createCoupon">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="detail.dialog" max-width="500px">
          <v-card>
            <v-card-title>
              <span class="headline">쿠폰 조회</span>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6>
                    <v-text-field
                      label="쿠폰 번호"
                      v-model="detailFormModel.id"
                      disabled></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-select
                      :items="state"
                      v-model="detailFormModel.state"
                      label="쿠폰 종류"
                      item-text="text"
                      item-value="state"
                      :disabled="chkDisabled"
                      >
                    </v-select>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      label="쿠폰 제목"
                      v-model="detailFormModel.title"
                      v-validate="detailFormRequired"
                      data-vv-name="newTitle"
                      :error-messages="errors.collect('newTitle')"
                      :required="detailFormRequire"
                      :disabled="chkDisabled"></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      label="쿠폰 설명"
                      v-model="detailFormModel.description"
                      v-validate="detailFormRequired"
                      data-vv-name="newDescription"
                      :error-messages="errors.collect('newDescription')"
                      :required="detailFormRequire"
                      :disabled="chkDisabled"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field
                      label="쿠폰 금액"
                      mask="####################"
                      v-model="detailFormModel.amount"
                      v-validate="detailFormRequired"
                      data-vv-name="newAmount"
                      :error-messages="errors.collect('newAmount')"
                      :required="detailFormRequire"
                      :disabled="chkDisabled"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field
                      label="유효 기간"
                      mask="####################"
                      v-model="detailFormModel.days"
                      v-validate="detailFormRequired"
                      data-vv-name="newDays"
                      :error-messages="errors.collect('newDays')"
                      :required="detailFormRequire"
                      :disabled="chkDisabled"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer>
              </v-spacer>
              <v-btn color="blue darken-1" flat @click="closeDialogDetail">Close</v-btn>
              <a id="detailSave" hidden><v-btn color="blue darken-1" flat @click="saveDetail">Save</v-btn></a>
              <a id="detailEdit"><v-btn color="blue darken-1" flat @click="editDetail">Edit</v-btn></a>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import VWidget from '@/components/VWidget';
import State  from '@/api/couponType';

export default {
  components: {
    VWidget
  },
  data () {
    return {
      formModel: {
        state: 'FREE_SERVICE_FEE'
      },
      detailFormModel: {
      },
      pagination: {
        sortBy: 'id',
        descending: true,
        rowsPerPage: 10,
        page: 1
      },
      totalItems: 0,
      searchFormModel: {
        filter: 'title',
        filterText: ''
      },
      complex: {
        headers: [
          {
            text: '쿠폰 고유번호',
            value: 'id',
            align: 'center'
          },
          {
            text: '이름',
            value: 'title',
            align: 'center'
          },
          {
            text: '설명',
            value: 'description',
            align: 'center'
          },
          {
            text: '종류',
            value: 'couponType',
            align: 'center'
          },
          {
            text: '금액',
            value: 'amount',
            align: 'center'
          },
          {
            text: '유효기간',
            value: 'days',
            align: 'center'
          },
          {
            text: '발급내역',
            value: 'history',
            align: 'center'
          },
        ],
        items: []
      },
      coupon: {
        dialog: false
      },
      detail: {
        dialog: false
      },
      state: State,
      chkDisabled: true,
      formRequired: '',
      detailFormRequired: '',
      detailFormRequire: true
    };
  },
  watch: {
    pagination: {
      handler () {
        if (top.getApp.prevPageName === 'CouponPage') {
          if(top.getApp.prevPagination != null) {
            this.pagination = top.getApp.prevPagination;
          }

          if(top.getApp.prevSearchFormModel != null) {
            this.searchFormModel = top.getApp.prevSearchFormModel;
          }

          top.getApp.clearPrevData();
        }

        this.banbanCreated();
      },
      deep: true
    }
  },
  mounted () {
    for (let i = 0; i < this.$parent.$children.length; i++) {
      if (this.$parent.$children[i].chkAutoReload != null) {
        this.$parent.$children[i].chkAutoReload();
      }
    }
  },
  methods: {
    banbanCreated () {
      const parameters = {
          method: 'searchCoupons',
          pageNum: this.pagination.page - 1,
          pageSize: this.pagination.rowsPerPage,
          sortName: this.pagination.sortBy,
          order: this.pagination.descending == true ? 'desc' : 'asc',
          filter: this.searchFormModel.filter,
          filterText: this.searchFormModel.filterText
      };

      this.$store.dispatch('banbanAPI', parameters)
        .then(({ data }) => {
          this.complex.items = data.content;
          this.totalItems = data.totalElements;
          top.getApp.progress.dialog = false;
        })
        .catch((error) => {
          if (top.getApp.commonError == null) {
            alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
          }
          top.getApp.commonError = null;
          top.getApp.progress.dialog = false;
        });
    },
    changeCouponTypeText (couponType) {
      if (couponType != null) {
        for (let i = 0; i < this.state.length; i++) {
          if (this.state[i].state === couponType) {
            return this.state[i].text;
          }
        }
      } else {
        return '-';
      }
    },
    openDialogCoupon () {
      this.formRequired = 'required';
      this.detailFormRequired = '';
      this.formModel = {
        state: 'FREE_SERVICE_FEE'
      };
      this.$validator.reset();
      this.coupon.dialog = true;
    },
    closeDialogCoupon () {
      this.coupon.dialog = false;
    },
    createCoupon () {
      this.$validator.validateAll()
        .then((validate) => {
          if (validate) {
            const prameters = {
              method: 'createCoupons',
              couponType: this.formModel.state,
              title: this.formModel.title,
              description: this.formModel.description,
              amount: this.formModel.amount,
              days: this.formModel.days,
            };
            this.$store.dispatch('banbanAPI', prameters)
              .then(({ data }) => {
                top.getApp.progress.dialog = false;
                this.coupon.dialog = false;
                this.banbanCreated();
              })
              .catch((error) => {
          if (top.getApp.commonError == null) {
            alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
          }
          top.getApp.commonError = null;
                top.getApp.progress.dialog = false;
              });
          }
        });
    },
    openDialogDetail (item) {
      this.formRequired = '';
      this.detailFormRequired = 'required';

      this.$validator.reset();

      this.detailFormModel = {
        id: item.id,
        state: item.couponType,
        title: item.title,
        description: item.description,
        amount: item.amount,
        days: item.days,
      };
      this.chkDisabled = true;
      document.getElementById('detailEdit').hidden = false;
      document.getElementById('detailSave').hidden = true;
      this.detail.dialog = true;
    },
    closeDialogDetail () {
      this.detail.dialog = false;
    },
    saveDetail () {
      this.$validator.validateAll()
        .then((validate) => {
          if (validate) {
            const prameters = {
              method: 'editCoupons',
              id: this.detailFormModel.id,
              couponType: this.detailFormModel.state,
              title: this.detailFormModel.title,
              description: this.detailFormModel.description,
              amount: this.detailFormModel.amount,
              days: this.detailFormModel.days,
            };
            this.$store.dispatch('banbanAPI', prameters)
              .then(({ data }) => {
                top.getApp.progress.dialog = false;
                this.chkDisabled = true;
                document.getElementById('detailEdit').hidden = false;
                document.getElementById('detailSave').hidden = true;
                this.detail.dialog = true;
                alert('수정되었습니다.');
              })
              .catch((error) => {
          if (top.getApp.commonError == null) {
            alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
          }
          top.getApp.commonError = null;
                top.getApp.progress.dialog = false;
              });
          }
        });
        
    },
    editDetail () {
      this.chkDisabled = false;
      document.getElementById('detailEdit').hidden = true;
      document.getElementById('detailSave').hidden = false;
    },
    openHistory (id) {
      top.getApp.addPrevData('CouponPage', this.pagination, this.searchFormModel);
      this.$router.push('/coupon/couponHistories/' + id);
    },
    searchFilter () {
      this.banbanCreated();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/coupon/Coupon.vue